var React = require('react');

function MobileIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".mobile-icon-svg-1{fill:#b4b4b4;}")),React.createElement("path",{"className":"mobile-icon-svg-1","d":"M5,0H3A3,3,0,0,0,0,3v7a3,3,0,0,0,3,3H5a3,3,0,0,0,3-3V3A3,3,0,0,0,5,0ZM4.5,12h-1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5A.5.5,0,0,1,4.5,12ZM6,10H2V3A1,1,0,0,1,3,2H5A1,1,0,0,1,6,3Z","key":1})]);
}

MobileIcon.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 8 13","width":"8","height":"13"};

module.exports = MobileIcon;

MobileIcon.default = MobileIcon;
